import styled from 'styled-components';

// UI comum das lentes (Pessoas, Produtos, ...). O motor não conhece estes
// componentes; cada tela compõe com a sua configuração de rede.

export const Shell = styled.div`
  position: relative;
  height: calc(100vh - 110px);
  min-height: 520px;
  overflow: hidden;
  background: #050b0c;
`;

export const Title = styled.div`
  position: absolute;
  top: 18px;
  left: 22px;
  z-index: 3;
  pointer-events: none;

  h1 {
    margin: 0;
    font-size: 19px;
    font-weight: 600;
    color: #eef4ff;
  }
  p {
    margin: 3px 0 0;
    font-size: 10.5px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #7c93b0;
  }
`;

export const Dock = styled.div`
  position: absolute;
  top: 16px;
  right: 22px;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Search = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 210px;
  padding: 7px 11px;
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(15, 23, 42, 0.55);
  color: #7c93b0;

  input {
    flex: 1;
    min-width: 0;
    border: 0;
    outline: none;
    background: transparent;
    color: #e6eefb;
    font-size: 12.5px;
  }
  input::placeholder { color: #6b7f99; }
  button { border: 0; background: transparent; color: #7c93b0; cursor: pointer; padding: 0; }
`;

export const Rail = styled.div`
  position: absolute;
  top: 64px;
  right: 22px;
  z-index: 3;
  width: 212px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Card = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.14);
  background: rgba(8, 14, 16, 0.66);
  backdrop-filter: blur(10px);
  padding: 10px 12px;
  color: #b9c8da;
`;

export const CardTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 9.5px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #6b7f99;
  margin-bottom: 8px;
`;

export const Levels = styled.div`
  display: flex;
  gap: 4px;
`;

export const LevelBtn = styled.button`
  width: 26px;
  height: 22px;
  border-radius: 6px;
  border: 1px solid ${(p) => (p.$active ? 'rgba(226, 232, 240, 0.38)' : 'rgba(148, 163, 184, 0.1)')};
  background: ${(p) => (p.$active ? 'rgba(226, 232, 240, 0.13)' : 'rgba(148, 163, 184, 0.04)')};
  color: ${(p) => (p.$active ? '#f1f5f9' : '#5a6b72')};
  font-size: 11px;
  font-weight: ${(p) => (p.$current ? 700 : 500)};
  cursor: pointer;
`;

export const FilterRow = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: 0;
  background: transparent;
  color: ${(p) => (p.$off ? '#4b5d75' : '#c3d1e2')};
  font-size: 11.5px;
  padding: 4px 0;
  cursor: pointer;
  text-align: left;

  i {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(p) => p.$color};
    opacity: ${(p) => (p.$off ? 0.3 : 1)};
  }
  b { margin-left: auto; color: #7c93b0; font-weight: 500; }
`;

export const Panel = styled.aside`
  position: absolute;
  top: 64px;
  left: 22px;
  z-index: 3;
  width: 230px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.14);
  background: rgba(8, 14, 16, 0.72);
  backdrop-filter: blur(10px);
  padding: 12px;
  color: #b9c8da;
`;

export const PanelHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;

  i { width: 9px; height: 9px; border-radius: 50%; background: #38bdf8; }
  strong { color: #eef4ff; font-size: 13px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; }
  button {
    margin-left: auto;
    border: 0;
    background: transparent;
    color: #7c93b0;
    cursor: pointer;
    padding: 0;
  }
`;

export const Meta = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 10px;
  font-size: 11.5px;
  margin-bottom: 10px;

  span { color: #6b7f99; }
  b { color: #d6e2f1; font-weight: 500; overflow: hidden; text-overflow: ellipsis; }
`;

export const Action = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid rgba(56, 189, 248, 0.32);
  background: rgba(56, 189, 248, 0.13);
  color: #d9f2ff;
  font-size: 11.5px;
  cursor: pointer;
`;
